import React from "react";
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';

import UserSubMenu from '../../Home/User/UserSubMenu';
import Footer from "../../Footer/FooterBottom";
import SchoolItem from "./SchoolItem";
import {
    fetchSchools as fetch,
    removeSchools as remove,
    undoSchools as undo,
    clearSchools as clear,
    addSchool as add,
    updateSchool as update,
    loadSchools
} from './actions';
import api from '../../../api/api';
import EditSchoolForm from '../../Home/Forms/EditSchoolForm';
import configDataCountries from "../../Config/countries.json";

class SchoolsList extends React.Component {

    state = {
        search: '',
        IsDeleted: false,
        IsActive: null,
        CountryCustom: null,
        showAdd: false,
        Email: "",
        Phone: "",
        Name: "",
        isStartSearch: false,
        Code: "",
        Limit: 20
    };

    constructor(props) {
        super(props);
        this._toastId = new React.createRef();
        window.scrollToTop();
        this.state.countries = configDataCountries.countries.sort((a, b) => a.label > b.label ? 1 : -1).map(item => {
            return {
                value: item.value,
                name: item.label,
                label: <div><LazyLoadImage src={process.env.PUBLIC_URL + item.icon} />  {item.label}</div>,
            };
        });
    }


    showAdd = () => {
        this.setState({
            showAdd: true
        });
    }

    handleCloseAdd = () => {
        this.setState({
            showAdd: false,
        });
    }

    setSearch = value => {
        this.setState({
            search: value
        });
    }

    showDelete = id => {
        if (id) {
            this.props.remove(id);
            const { t } = this.props;

            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });

            toast.update(_toastId, {
                render: () => <div>
                    <i className="fa-spin fas fa-spinner"></i> {t('DeleteProcessing')}
                    <div className="row row-cols-2">
                        <div className="col">
                            <button type="button" className="btn btn-danger btn-block " onClick={() => { this.undoDelete(id); toast.dismiss(_toastId); }}>
                                <i className="icon fal fa-trash-undo"></i> {t('undo')}
                            </button>
                        </div>
                        <div className="col">
                            <button type="button" className="btn btn-light btn-block " onClick={() => { this.deleteItem(id); toast.dismiss(_toastId); }}>
                                <i className="icon fal fa-recycle"></i> {t('confirm')}
                            </button>
                        </div>
                    </div>
                </div>,
                type: toast.TYPE.DARK,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true
            });

        }
    }

    deleteItem = id => {
        const { t } = this.props;

        let _toastId = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(_toastId, {
            render: () => <div> <i className="fa-spin fas fa-spinner"></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        api.delete(`/Schools/${id}`).then(response => {

            this.props.clear(id);

            toast.update(_toastId, {
                render: () => <div><div className="h5"> <i className="icon fal fa-exclamation-triangle"></i> {t('Pages.SchoolsControl.toast.Delete.Title')}</div> <div className="h6">{t('Pages.SchoolsControl.toast.Delete.Body')}</div></div>,
                type: toast.TYPE.SUCCESS,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });

        }).catch(error => {
            toast.update(_toastId, {
                render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });
    }

    undoDelete = id => {
        this.props.undo(id);
    }

    renderSchools() {
        const { t, schools } = this.props;
        let isLoaded = false;
        let toRemove = [];

        if (schools) {
            toRemove = schools.toRemove;
            isLoaded = schools.isLoaded;
        }


        if (schools && schools.schools && schools.schools.length > 0) {
            let filterSchools = schools.schools.filter(v => v.Name.includes(this.state.search));

            if (isLoaded === false) {
                return (
                    <div className="product-list-item" >
                        <div className="product-content w-100 text-center ">
                            <div className="display-1 text-danger">
                                <i className="fad fa-sync-alt fa-spin"></i>
                            </div>
                            <h4 className="display-3 subtitle">
                                {t("Pages.SchoolsControl.Loading")}
                            </h4>
                        </div>
                    </div>
                );
            }

            if (filterSchools.length === 0 && this.state.search) {
                return (
                    <div className="product-list-item" >
                        <div className="product-content w-100 text-center ">
                            <div className="display-1 text-danger">
                                <i className="fad fa-telescope"></i>
                            </div>
                            <h4 className=" subtitle">
                                {t("Pages.SchoolsControl.NotFound")}
                            </h4>
                            <div className="h2 text-danger">
                                "{this.state.search}"
                                {t("Pages.SchoolsControl.IsNotHere")}
                            </div>
                        </div>
                    </div>
                );
            }

            return filterSchools.map(school =>
                (toRemove && toRemove.includes(school.Id)) ? "" :
                    <SchoolItem
                        key={school.Id}
                        item={school}
                        update={this.props.update}
                        remove={this.showDelete}
                    />
            );
        }

        if (schools && schools.schools && schools.isLoaded === false) {
            return (
                <div className="product-list-item" >
                    <div className="product-content w-100 text-center ">
                        <div className="display-1 text-danger">
                            <i className="fad fa-sync-alt fa-spin"></i>
                        </div>
                        <h4 className="display-3 subtitle">
                            {t("Pages.SchoolsControl.Loading")}
                        </h4>
                    </div>
                </div>
            );
        }

        return (
            <div className="product-list-item" >
                <div className="product-content w-100 text-center ">
                    <div className="display-1 text-danger">
                        <i className="fad fa-telescope"></i>
                    </div>
                    <h4 className="display-3 subtitle">
                        {t("Pages.SchoolsControl.NotFound")}
                    </h4>
                </div>
            </div>
        );
    }

    Sync = () => {
        this.setState({
            isStartSearch: true
        });
        this.props.loadSchools();
        setTimeout(() => {
            this.props.fetch(
                {
                    Country: this.Country.state.value ? this.Country.state.value.value : "",
                    CountryCustom: this.state.CountryCustom,
                    IsLocked: this.state.IsLocked,
                    IsDeleted: this.state.IsDeleted,
                    Email: this.state.Email,
                    Phone: this.state.Phone,
                    Limit: this.state.Limit,
                    Name: this.state.Name,
                    Code: this.state.Code
                }
            );
        }, 500);
    }

    onSubmit = (postData, _toastId) => {
        const { t } = this.props;

        api.post(`/Schools/`,
            postData
        ).then(response => {
            if (response.data.code === "success") {

                this.props.add(response.data.data);

                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.SchoolsControl.toast.Add.Title')}</div> <div className="h6">{t('Pages.SchoolsControl.toast.Add.Body')}</div></div>,
                    type: toast.TYPE.SUCCESS,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                this.handleCloseAdd();

            } else {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Title')}</div> <div className="h6">{t('Pages.ProfileEdit.error_AllInformationIsRequired_toast.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }).catch(error => {
            toast.update(_toastId, {
                render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });
    }

    filterOptions = (candidate, input) => {
        if (input) {
            return candidate.data.name.includes(input);
        }
        return true;
    }

    setLimit = Limit => {
        this.setState({
            Limit
        });
    }

    setCountry = CountryCustom => {
        this.setState({
            CountryCustom
        });
    }

    setPhone = Phone => {
        this.setState({
            Phone
        });
    }

    setCode = Code => {
        this.setState({
            Code
        });
    }

    setName = Name => {
        this.setState({
            Name
        });
    }

    setIsLocked = IsLocked => {
        this.setState({
            IsLocked
        });
    }

    setEmail = Email => {
        this.setState({
            Email
        });
    }

    setIsDeleted = IsDeleted => {
        this.setState({
            IsDeleted
        });
    }

    render() {
        const { t, user } = this.props;

        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.SchoolsControl.title')} | {t('alarabeyya')}
                    </title>
                </Helmet>
                {
                    this.state.showAdd ?
                        <Modal
                            size="lg"
                            centered
                            backdrop="static"
                            keyboard={false}
                            enforceFocus={false}
                            show={this.state.showAdd}
                            onHide={this.handleCloseAdd}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <div className="h5 mb-0">
                                        <i className="fad fa-plus text-primary icon"></i> {t("Pages.SchoolsControl.Add")}
                                    </div>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget widget-category">
                                    <div className="widget-body">
                                        <EditSchoolForm
                                            isAdmin={true}
                                            onSubmit={this.onSubmit}></EditSchoolForm>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        : ""
                }

                <section className="pos-rel padding-bottom padding-top ">
                    <div className="top-shape-center">
                        <LazyLoadImage src="/assets/css/img/gallery1.png" alt={`${t('alarabeyya')}`} />
                    </div>
                    <div className="bottom-shape-left">
                        <LazyLoadImage src="/assets/css/img/bottom-shape.png" alt={`${t('alarabeyya')}`} />
                    </div>
                    <div className="container">


                        <div className="row ">
                            <div className="col-lg-12 mb-50">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="section-header">
                                            <h3 className="title">{t('Pages.SchoolsControl.title')}</h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="widget widget-category" >

                                    <div className="widget-header">
                                        <h5 className="title">
                                            <i className="fal fa-search "></i> {t('Pages.UsersControl.advancedSearch.title')}
                                        </h5>
                                    </div>
                                    <div className="widget-body">
                                        <div className="contact-form">
                                            <div className="row">
                                                <div className="form-group col-md-3">
                                                    <div>
                                                        <Select
                                                            defaultValue={this.state.CountryIndex >= 0 ? {
                                                                label: this.state.countries[this.state.CountryIndex].label,
                                                                value: this.state.countries[this.state.CountryIndex].value
                                                            } : ""}
                                                            name="Country"
                                                            placeholder={t('Pages.Register.Country.Placeholder')}
                                                            isClearable={true}
                                                            isRtl={true}
                                                            isSearchable={true}
                                                            ref={Country => this.Country = Country}
                                                            options={this.state.countries}
                                                            filterOption={this.filterOptions}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 0,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#92278f',
                                                                    primary: '#92278f',
                                                                },
                                                            })}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <select
                                                        defaultValue={this.state.Country}
                                                        onChange={e => this.setCountry(e.target.value)}
                                                        className="form-control"
                                                        name="CountryCustom"
                                                        title={t("Pages.UsersControl.advancedSearch.Country.title")}  >
                                                        <option value="">{t("Pages.UsersControl.advancedSearch.Country.title")}  </option>
                                                        <option value={false}>{t("Pages.UsersControl.advancedSearch.Country.OutSide")}  </option>
                                                        <option value={true}>{t("Pages.UsersControl.advancedSearch.Country.InSide")}  </option>
                                                    </select>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <select
                                                        defaultValue={this.state.IsLocked}
                                                        onChange={e => this.setIsLocked(e.target.value)}
                                                        className="form-control"
                                                        name="IsLocked"
                                                        title={t("Pages.UsersControl.advancedSearch.IsLocked")}  >
                                                        <option value="">{t("Pages.UsersControl.advancedSearch.IsLocked")}  </option>
                                                        <option value={false}>{t("Pages.UsersControl.NotLocked")}  </option>
                                                        <option value={true}>{t("Pages.UsersControl.Locked")}  </option>
                                                    </select>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <input
                                                        defaultValue={this.state.Name}
                                                        onChange={e => this.setName(e.target.value)}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t("Pages.UsersControl.advancedSearch.name")}
                                                        title={t("Pages.UsersControl.advancedSearch.name")} />
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <input
                                                        defaultValue={this.state.Email}
                                                        onChange={e => this.setEmail(e.target.value)}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t("Pages.UsersControl.advancedSearch.email")}
                                                        title={t("Pages.UsersControl.advancedSearch.email")} />
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <input
                                                        defaultValue={this.state.Phone}
                                                        onChange={e => this.setPhone(e.target.value)}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t("Pages.UsersControl.advancedSearch.phone")}
                                                        title={t("Pages.UsersControl.advancedSearch.phone")} />
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <select
                                                        defaultValue={this.state.IsDeleted}
                                                        onChange={e => this.setIsDeleted(e.target.value)}
                                                        className="form-control"
                                                        name="IsDeleted"
                                                        title={t("Pages.UsersControl.advancedSearch.IsDeleted")}  >
                                                        <option value={false}>{t("Pages.SchoolsControl.IsNotDeleted")}  </option>
                                                        <option value={true}>{t("Pages.SchoolsControl.IsDeleted")}  </option>
                                                    </select>
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <input
                                                        defaultValue={this.state.Code}
                                                        onChange={e => this.setCode(e.target.value)}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t("Pages.UsersControl.advancedSearch.Code")}
                                                        title={t("Pages.UsersControl.advancedSearch.Code")} />
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <input
                                                        defaultValue={this.state.Limit}
                                                        onChange={e => this.setLimit(e.target.value)}
                                                        type="number"
                                                        step={1}
                                                        className="form-control"
                                                        placeholder={t("Pages.UsersControl.advancedSearch.limit")}
                                                        title={t("Pages.UsersControl.advancedSearch.limit")} />
                                                </div>

                                                <div className="form-group col-md-3">
                                                    <button className="custom-button" onClick={() => this.Sync()} title={t("Pages.UsersControl.Sync")} >
                                                        <span>
                                                            <i className="fas fa-sync-alt mx-1"></i>
                                                            {t('Pages.UsersControl.advancedSearch.send')}
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div className="row ">
                                    <div className="col-lg-8">

                                        <div className="widget widget-search" >
                                            <div className="widget-body">
                                                <div className="d-flex">
                                                    <div className="p-2 flex-grow-1 ">
                                                        <form className="search-form">
                                                            <input type="text" onChange={e => this.setSearch(e.target.value)} defaultValue={this.state.search} placeholder={t("Pages.SchoolsControl.search")} />
                                                            <button type="button"><i className="fas fa-search"></i></button>
                                                        </form>
                                                    </div>
                                                    <div className="pt-3">
                                                        <div onClick={() => this.showAdd()} title={t("Pages.SchoolsControl.Add")} className="btn btn-primary mx-1">
                                                            <i className="fas fa-plus"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.isStartSearch ? this.renderSchools() : ""
                                        }
                                    </div>
                                    <div className="col-lg-4 mb-50">
                                        <aside>
                                            <UserSubMenu user={user} />
                                        </aside>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <Footer />
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        schools: state.schools
    };
};

export default connect(mapStateToProps, { loadSchools, fetch, add, remove, clear, undo, update })(withTranslation('common')(SchoolsList));
